export class CuttingTask {
  id: number;
  pID: number;
  dateFinish?: Date;
  orderId: number;
  stateCuttingTask: StateCuttingTaskEnum;
  dateStart: Date;
  log: string;
  checkedByClient: boolean;
  usedPersonalCuttingSettings: boolean;

  constructor(task?: CuttingTask | any) {
    task = task || {};
    this.id = task.id || 0;
    this.orderId = task.orderId || 0;
    this.pID = task.pID || 0;
    this.dateStart = task.dateStart || new Date();
    this.stateCuttingTask = task.stateCuttingTask || StateCuttingTaskEnum.Success;
    this.dateFinish = task.dateFinish || null;
    this.log = task.log || '';
    this.checkedByClient = task.checkedByClient || true;
    this.usedPersonalCuttingSettings = task.usedPersonalCuttingSettings || false;
  }
}

export enum StateCuttingTaskEnum {
  Wait,
  Error,
  Success,
}
